import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { ReactComponent as ToggleIcon } from "../../assets/images/toggle-icon.svg";

import {
  NAV_STYLE_DRAWER,
  NAV_STYLE_FIXED,
  NAV_STYLE_MINI_SIDEBAR,
  NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
  TAB_SIZE,
  THEME_TYPE_LITE
} from "../../constants/ThemeSetting";
import { onNavStyleChange } from "appRedux/actions";

const SidebarLogo = () => {
  const dispatch = useDispatch();

  const { navStyle: navStyleFromState, themeType, width, navCollapsed } = useSelector(
    ({ settings }) => settings
  );

  let navStyle = navStyleFromState;
  if (width < TAB_SIZE && navStyle === NAV_STYLE_FIXED) {
    navStyle = NAV_STYLE_DRAWER;
  }

  const handleMenuToggle = () => {
    //console.log("navStyle", navStyle);
    if (navStyle === NAV_STYLE_DRAWER) {
      dispatch(toggleCollapsedSideNav(!navCollapsed));
    } else if (navStyle === NAV_STYLE_FIXED) {
      dispatch(onNavStyleChange(NAV_STYLE_MINI_SIDEBAR));
    } else if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
      dispatch(toggleCollapsedSideNav(!navCollapsed));
    } else {
      dispatch(onNavStyleChange(NAV_STYLE_FIXED));
    }
  };

  return (
    <div className="gx-layout-sider-header">
      <Link to="/" className="gx-site-logo">
          { navStyle === NAV_STYLE_MINI_SIDEBAR ? 
          <img alt="logo" src={require("assets/images/clarity-logo-short.png")} />
          :
          <img alt="logo" src={require("assets/images/sidebar-logo.png")} />
          } 
      </Link>
      <ToggleIcon className="toggle-icon" onClick={handleMenuToggle} />
    </div>
  );
};

export default SidebarLogo;
